// extracted by mini-css-extract-plugin
export var anchor = "bk_dM";
export var anchors = "bk_dL";
export var document = "bk_dQ";
export var documents = "bk_dP";
export var heading = "bk_G";
export var privacy = "bk_dN";
export var section = "bk_j";
export var tariff = "bk_dS";
export var tariffs = "bk_dR";